import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAirlineSeat300 = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 -960 960 960",
	width: "24px",
	fill: "#1f1f1f",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M595-180H327.31Q297-180 276-201q-21-21-21-51.31V-680h60v427.69q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85H595v60ZM445-710q-30.69 0-52.27-21.58-21.58-21.57-21.58-52.26 0-30.7 21.58-52.27 21.58-21.58 52.27-21.58 30.69 0 52.27 21.58 21.57 21.57 21.57 52.27 0 30.69-21.57 52.26Q475.69-710 445-710ZM645-90v-190H425q-29.15 0-49.58-20.42Q355-320.85 355-350v-225.38q0-38.16 25.92-64.08 25.93-25.92 64.08-25.92t64.08 25.92Q535-613.54 535-575.38V-380h100q29.15 0 49.58 20.42Q705-339.15 705-310v220h-60Z" })
});
export default SvgAirlineSeat300;
